import React, { createContext, useContext, useState, useEffect } from "react";

const FastStaffContext = createContext();

export const FastStaffProvider = ({ children }) => {
  const [activeStaff, setActiveStaff] = useState(() => {
    const stored = localStorage.getItem("activeStaff");
    return stored ? JSON.parse(stored) : null;
  });

  // Save to localStorage whenever activeStaff changes
  useEffect(() => {
    if (activeStaff) {
      localStorage.setItem("activeStaff", JSON.stringify(activeStaff));
      localStorage.setItem("fastSwitchUnlocked", "true");
    } else {
      localStorage.removeItem("activeStaff");
      localStorage.removeItem("fastSwitchUnlocked");
    }
  }, [activeStaff]);

  const logoutStaff = () => {
    setActiveStaff(null);
    // localStorage is cleaned up by the useEffect above
  };

  return (
    <FastStaffContext.Provider
      value={{ activeStaff, setActiveStaff, logoutStaff }}>
      {children}
    </FastStaffContext.Provider>
  );
};

export const useFastStaff = () => useContext(FastStaffContext);
